<template>
  <div>
    <v-sheet elevation="2" class="news-sheet">
      <v-col cols="12" sm="6" md="3" class="mx-auto pb-0">
        <v-text-field
          outlined
          label="Search News"
          prepend-inner-icon="mdi-magnify"
          dense
          class="mb-0"
          v-model="query"
          clearable
          color="teal"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="10"
        sm="10"
        class="mx-auto"
        v-for="news in searchNews"
        :key="news._id"
      >
        <!-- <base-title-bar
            elevation="2"
            class="text-center"
            color="#17408B"
            :label="`${news.Title}`"
            icon="mdi-baseball-bat"
            height="60"
            textProp="pt-2 pb-1text-subtitle-1 white--text"
          /> -->

        <!--//* goalies cards.. -->
        <v-card class="mx-auto" rounded elevation="2">
          <v-card-text>
            <span class="caption font-weight-black">
              {{ news.Updated | UtcToEst }}
            </span>
            <v-avatar
              color="grey"
              class="float-left mx-2"
              width="50"
              height="50"
            >
              <img :src="news.PhotoUrl" alt="" />
            </v-avatar>
            <p class="text-subtitle-1 font-weight-bold">{{ news.Title }}</p>
            <p>{{ news.Content }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
import { UtcToEst } from "@/filters/day";
import { mapState } from "vuex";
export default {
  name: "team_newsPage",

  data() {
    return {
      query: "",
    };
  },

  computed: {
    ...mapState("userModule", ["team_news"]),
    searchNews() {
      if (this.team_news.data) {
        let news = this.team_news.data.map((_news) => {
          _news.hash =
            `${_news.Categories} ${_news.Team} ${_news.Title}`.toLowerCase();
          return _news;
        });

        news = news.filter((n) => n.hash.includes(this.query.toLowerCase()));
        return news;
      }
    },
  },

  methods: {
    estTime(value) {
      const datetime = new Date(value);
      const time = datetime.toLocaleString("en-US", {
        timeZone: "America/New_York",
      });

      console.log(time);
    },
  },
};
</script>

<style scoped>
.news-sheet {
  background: #c2e6cf !important;
  max-height: 500px;
  overflow: auto;
}
</style>
